import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import {
    FacebookShareButton,
    TwitterShareButton,
    EmailShareButton,
    FacebookIcon,
    TwitterIcon,
    EmailIcon,
} from 'react-share';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './Share.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Share extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        let facebook = document.querySelector('.SocialMediaShareButton--facebook');
        let facebookSVG = document.querySelector('.SocialMediaShareButton--facebook svg');
        facebook.setAttribute('aria-label', 'Share on Facebook');
        facebookSVG.setAttribute('aria-hidden', true);

        let twitter = document.querySelector('.SocialMediaShareButton--twitter');
        let twitterSVG = document.querySelector('.SocialMediaShareButton--twitter svg');
        twitter.setAttribute('aria-label', 'Share on Twitter');
        twitterSVG.setAttribute('aria-hidden', true);

        let email = document.querySelector('.SocialMediaShareButton--email');
        let emailSVG = document.querySelector('.SocialMediaShareButton--email svg');
        email.setAttribute('aria-label', 'Share by Email');
        emailSVG.setAttribute('aria-hidden', true);
    }

    render() {
        const shareURL = `${process.env.REACT_APP_SITE_URL}/event-details/${this.props.event.details.event_id}`;
        const title = this.props.content || `${strings.content} ${this.props.event.details.name} here: ${shareURL}`;
        const iconSize = (this.props.iconSize) ? this.props.iconSize : 32;
        return (
            <div className={(this.props.isInline ? "showtix-share showtix-background__primary-2 is-inline" : "showtix-share showtix-background__primary-2")}>
                <FacebookShareButton
                    url={shareURL}
                    quote={title}
                    className="showtix-share__button"
                >
                    <FacebookIcon
                        size={iconSize}
                        round
                    />
                </FacebookShareButton>
                <TwitterShareButton
                    url={shareURL}
                    quote={title}
                    className="showtix-share__button"
                >
                    <TwitterIcon
                        size={iconSize}
                        round
                    />
                </TwitterShareButton>
                <EmailShareButton
                    url={shareURL}
                    subject={this.props.event.details.name}
                    body={title}
                    className="showtix-share__button"
                >
                    <EmailIcon
                        size={iconSize}
                        round
                    />
                </EmailShareButton>
            </div>
        )
    }
}

Share.propTypes = {
    event: PropTypes.shape({
        details: PropTypes.shape({
            searchTerm: PropTypes.string,
            existingMitShows: PropTypes.array,
            event_type: PropTypes.string,
            contact_email: PropTypes.string,
            event_name: PropTypes.string,
            contact_phone: PropTypes.string,
            short_name: PropTypes.string,
            tickets_per_user: PropTypes.string,
            desc: PropTypes.string,
            mti_show: PropTypes.bool,
            event_website: PropTypes.string,
            service_fee: PropTypes.string,
            playbilder_url: PropTypes.string
        })
    })
}
 
export default Share;


// WEBPACK FOOTER //
// ./src/components/Common/Share/Share.js